export default __webpack_public_path__ + "static/media/q27.8fa23bc1.png";